import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

lessRequire('modules/root/components/login-form.less');

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	register
}) => {
	return (
		<form className="register__form" onSubmit={handleSubmit(formData => register(formData))}>
			<h2>Register</h2>
			<div className="register__form-element">
				<Field name="email" component="input" type="text" placeholder="Email"/>
			</div>

			<div className="register__form-element">
				<Field name="password" component="input" type="password" placeholder="Password"/>
			</div>

			<div className="login__form-element">
				<div className="login__form-element">
					<button type="submit" disabled={pristine || submitting}>Register</button>
				</div>
			</div>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	submitting: PropTypes.bool,
	register: PropTypes.func
};

export default reduxForm({
	form: 'registerForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/register-form.js